module.exports = __webpack_public_path__ + "img/cloth_g1_hat_15.adf0f1ff.svg";